import React from 'react';

// Pricing Section
export const PricingSection = () => {
  const servicesPrices = [
    { service: 'Repas a oprava svetlometov', price: 'na dopyt' },
    { service: 'Výmena plexiskla svetlometov', price: 'od 120€ / ks' },
    { service: 'Oprava denného svietenia (DRL)', price: 'na dopyt' },
    { service: 'Výmena vysvietených parabolí', price: 'na dopyt' },
    { service: 'PPF ochrana svetlometov', price: 'od 50€ / ks' },
  ];

  const interiorPrices = [
    { service: 'Inštalácia ambient osvetlenia', price: 'od 300€' },
    { service: 'Inštalácia hviezdneho stropu', price: 'od 700€' },
    { service: 'Dechrom svetlometov', price: 'na dopyt' },
    { service: 'LED žiarovky (pár)', price: 'od 50€' },
    { service: 'Demontáž / Montáž nárazníka', price: '40€' },
  ];

  const PriceTable = ({ title, items, startIndex }) => (
    <div className="bg-white/5 border border-white/10 overflow-hidden">
      <div className="px-6 py-4 border-b border-white/10 bg-white/[0.03]">
        <h3 className="text-sm font-bold uppercase tracking-[0.15em] text-[#00BFFF]">{title}</h3>
      </div>
      <table className="w-full">
        <thead>
          <tr className="border-b border-white/10">
            <th className="text-left py-3 px-6 text-zinc-500 font-medium text-xs uppercase tracking-wider">Služba</th>
            <th className="text-right py-3 px-6 text-zinc-500 font-medium text-xs uppercase tracking-wider">Cena</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr 
              key={index}
              data-testid={`price-row-${startIndex + index}`}
              className="border-b border-white/5 last:border-0 hover:bg-white/[0.02] transition-colors"
            >
              <td className="py-4 px-6 text-sm md:text-base">{item.service}</td>
              <td className="py-4 px-6 text-right text-[#00BFFF] font-medium text-sm md:text-base whitespace-nowrap">
                {item.price}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <section id="pricing" data-testid="pricing-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00BFFF] mb-4">
            Cenník
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl tracking-tight font-medium">
            Cenník služieb
          </h2>
          <p className="text-zinc-400 mt-4 max-w-2xl mx-auto">
            Kvalitná práca za férové ceny. Bez skrytých poplatkov.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-8">
          <PriceTable title="Cenník služieb" items={servicesPrices} startIndex={0} />
          <PriceTable title="Úpravy interiéru a dizajnu" items={interiorPrices} startIndex={5} />

          <p className="text-center text-zinc-500 text-sm">
            * Uvedené ceny sú orientačné podľa typu vozidla a rozsahu poškodenia.
          </p>
        </div>
      </div>
    </section>
  );
};
